import { API_ENDPOINTS } from '../constants/api-endpoint.constants';
import type { TApiHttpMethod } from '../types/analytics-events.types';

export const pickHttpMethods = () =>
  [...new Set(Object.values(API_ENDPOINTS).map(({ httpMethod }) => httpMethod))] as [TApiHttpMethod, ...Array<TApiHttpMethod>];
